import React, { useState, ReactDOM, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import './findingsSlider.scss';
import './reportsSlider.scss';
function ReportSlider() {
    const [currentReport, setCurrentReport] = useState(1);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const report = urlParams.get('report');
        if (!isNaN(report) && parseInt(report) > 0 && parseInt(report) < REPORTS.length + 1) {
            //Because we got these reports out of order, we do this because we still want them to appear in a certain way and play friendly with old urls
            if (parseInt(report) === 2) {
                setCurrentReport(3);
            }
            else if (parseInt(report) === 3) {
                setCurrentReport(2);
            }
            else {
                setCurrentReport(parseInt(report));
            }
        }
    }, []);

    const incrementReport = () => {
        if (currentReport >= REPORTS.length) return;
        setCurrentReport((prevValue) => prevValue + 1);
    };
    const decrementReport = () => {
        if (currentReport <= 1) return;
        setCurrentReport((prevValue) => prevValue - 1);
    };

    const changeReport = (clickedReport) => {
        if (currentReport == clickedReport) {
            return;
        } else {
            setCurrentReport(clickedReport);
        }
    };

    return (
        <>
            <div className="report-slider-container">
                <div className="controls-container">
                    {REPORTS.length > 1 && (
                        <>
                            <ArrowNavigators
                                className="arrow-navigators"
                                selectedReport={currentReport}
                                increment={incrementReport}
                                decrement={decrementReport}
                            />
                            <ProgressBar
                                report={currentReport}
                                className="progress-bar"
                                handleLabelClick={changeReport}
                            />
                        </>
                    )}
                </div>
                <DisplayReportSection className="display-report" report={currentReport} />
            </div>
            <MobileMenu />
        </>
    );
}
function FindingsSlider() {
    const [currentSlide, setCurrentSlide] = useState(1);
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const finding = urlParams.get('finding');
        if (!isNaN(finding) && parseInt(finding) > 0 && parseInt(finding) < 6) {
            setCurrentSlide(parseInt(finding))
        }
    }, []);
    const handleNavClick = (clickedNav) => {
        if (clickedNav == currentSlide) return;
        setCurrentSlide(clickedNav);
    };
    return (
        <div id="glf-slider">
            <div>
                <SliderNavigation
                    updatePosition={handleNavClick}
                    currentPosition={currentSlide}
                />
            </div>
            <div>
                <SliderContent currentPosition={currentSlide} />
            </div>
            <div>
                <SliderFooter currentPosition={currentSlide} />
            </div>
        </div>
    );
}

const slider1Container = document.getElementById("report-series");
const slider2Container = document.getElementById("report-findings-2025");
const root1 = createRoot(slider1Container);
const root2 = createRoot(slider2Container);
root1.render(<ReportSlider />);
root2.render(<FindingsSlider />);


/////////////////////////////////////////////////
/////////////////////////////////////////////////
///////////////Data
const REPORTS = [
    { 
        title: "Global Leadership Forecast 2025: Insights and Trends",
        description: [
            "The Global Leadership Forecast 2025 delivers critical insights into today’s top leadership challenges, including bench strength, trust, and CEOs’ top concerns. For the first time, the report explores AI's impact on leadership roles, teams, and strategies. Based on rigorous research and global data collection, the forecast comprehensively examines the complexities of leadership development, highlighting skill gaps, talent challenges, and the evolving expectations of modern leaders.",
            "Gain insight into the strategies that enable organizations to develop effective, adaptable leadership teams to tackle today’s challenges and seize tomorrow’s opportunities."
        ],
        coverURL:
            "https://assets-us-01.kc-usercontent.com/469992e5-7cbd-0032-ead4-f2db9237053a/32869bc1-ddc4-4ad0-bf93-234df1aa2d33/GLF2025-cover_final.jpg?fm=webp&q=15",
        ctaURL: "https://media.ddiworld.com/research/global-leadership-forecast-2025-report.pdf",
        btnTheme: "lgt-blue",
        ctaText: "Download Global Report",
        reportHTML: {
            __html: `<p class="report-description type--paragraph-base">The <i>Global Leadership Forecast 2025</i> delivers critical insights into today’s top leadership challenges, including bench strength, trust, and CEOs’ top concerns. For the first time, the report explores AI's impact on leadership roles, teams, and strategies.Based on rigorous research and global data collection, the forecast comprehensively examines the complexities of leadership development, highlighting skill gaps, talent challenges, and the evolving expectations of modern leaders.</p><p class="report-description type--paragraph-base">Gain insight into the strategies that enable organizations to develop effective, adaptable leadership teams to tackle today’s challenges and seize tomorrow’s opportunities.</p>`
        },        
        titleHTML: {
            __html: `<h2 class="report-title"><i>Global Leadership Forecast 2025</i>: Insights and Trends</h2>`
        }

    },
    {
        title: "HR Insights Report 2025: Strategies for HR's Defining Moment",
        description: [
            "The HR Insights Report 2025, part of DDI’s <i>Global Leadership Forecast<i/> series, uncovers the most urgent leadership challenges facing HR today—from succession planning and measuring impact to Gen Z turnover and AI transformation.",
            "Drawing on insights from over 2,000 HR professionals, this report highlights the seismic shift from reactive HR to anticipatory leadership. It reveals how HR leaders can build stronger pipelines, drive business results, and prove the ROI of leadership initiatives, positioning HR as an engine of competitive advantage.",
            "Uncover what sets high-impact HR apart—those stuck managing the status quo versus those shaping the future. "
        ],
        coverURL:
            "https://assets-us-01.kc-usercontent.com/469992e5-7cbd-0032-ead4-f2db9237053a/672c776d-7091-4e26-a35e-1ff64734a44c/HR_GLF_Subreport_cover_618x800.jpg?fm=webp&q=15",
        ctaURL: "https://media.ddiworld.com/research/ddi-hr-insights-report-2025.pdf",
        btnTheme: "lgt-purple",
        ctaText: "Download HR Report",
        reportHTML: {
            __html: `<p class="report-description type--paragraph-base">The <i>HR Insights Report 2025</i>, part of DDI’s <i>Global Leadership Forecast<i/>np series, uncovers the most urgent leadership challenges facing HR today—from succession planning and measuring impact to Gen Z turnover and AI transformation.</p><p class="report-description type--paragraph-base">Drawing on insights from over 2,000 HR professionals, this report highlights the seismic shift from reactive HR to anticipatory leadership. It reveals how HR leaders can build stronger pipelines, drive business results, and prove the ROI of leadership initiatives, positioning HR as an engine of competitive advantage.</p><p class="report-description type--paragraph-base">Uncover what sets high-impact HR apart—those stuck managing the status quo versus those shaping the future.</p>`
        },
        titleHTML: {
            __html: `<h2 class="report-title"><i>HR Insights Report 2025</i>: Strategies for HR's Defining Moment</h2>`
        }
    },
    {
        title: "Europe Leadership Report 2025: Trends, Challenges, and Solutions",
        description: [
            "The Europe Leadership Report 2025, part of DDI’s <i>Global Leadership Forecast<i/> series, provides essential insights into evolving leadership challenges across Europe.",
            "Amid economic turbulence, technological advancements, and shifting workforce dynamics, European leaders face unprecedented pressure to adapt. The report spotlights critical concerns, including leadership stress, trust deficits, readiness for AI integration, and gaps in frontline leaders’ sense of purpose.",
            "Discover evidence-based strategies to rebuild trust, ignite purpose, and cultivate resilient leadership in an ever-changing business landscape."
        ],
        coverURL:
            "https://assets-us-01.kc-usercontent.com/469992e5-7cbd-0032-ead4-f2db9237053a/2a9ca56e-09d7-426e-b011-4acea78488c7/GLFCover_Europe.jpg?fm=webp&q=15",
        ctaURL: "https://media.ddiworld.com/research/europe-leadership-report-2025.pdf",
        btnTheme: "lgt-green",
        ctaText: "Download Europe Report",
        reportHTML: {
            __html: `<p class="report-description type--paragraph-base">The <i>Europe Leadership Report 2025</i>, part of DDI’s Global Leadership Forecast series, provides essential insights into evolving leadership challenges across Europe. </p><p class="report-description type--paragraph-base">Amid economic turbulence, technological advancements, and shifting workforce dynamics, European leaders face unprecedented pressure to adapt. The report spotlights critical concerns, including leadership stress, trust deficits, readiness for AI integration, and gaps in frontline leaders’ sense of purpose.</p><p class="report-description type--paragraph-base">Discover evidence-based strategies to rebuild trust, ignite purpose, and cultivate resilient leadership in an ever-changing business landscape.</p>`
        },
        titleHTML: {
            __html: `<h2 class="report-title"><i>Europe Leadership Report 2025</i>: Trends, Challenges, and Solutions</h2>`
        }
    },
];
const REPORTMARKUP = { __html: '<p>some raw html</p>' }
const FINDINGS = [
    {
        footerDescription: "From 2022 to 2024, trust in immediate managers plummeted 17 points.",
        footerStickerURL: "https://assets-us-01.kc-usercontent.com/469992e5-7cbd-0032-ead4-f2db9237053a/295180b2-815d-401d-8d26-02bbe654923b/findings_callout_trust_and_credibility.png?fm=webp&q=15"
    },
    {
        footerDescription: "Frontline managers 3X more likely to be concerned  about AI than senior leaders.",
        footerStickerURL: "https://assets-us-01.kc-usercontent.com/469992e5-7cbd-0032-ead4-f2db9237053a/47042df4-3512-4e30-9f3d-e4b65b8bd081/findings_callout_ai_at_work.png?fm=webp&q=15"
    },
    {
        footerDescription: "40% of stressed leaders considered leaving their leadership role.",
        footerStickerURL: "https://assets-us-01.kc-usercontent.com/469992e5-7cbd-0032-ead4-f2db9237053a/6ca3ac9e-6182-4a7b-80d3-3706556bd812/findings_callout_stress_and_retention.png?fm=webp&q=15"
    },
    {
        footerDescription: "More than half of CEOs rank attracting and retaining top talent as their primary concern.",
        footerStickerURL: "https://assets-us-01.kc-usercontent.com/469992e5-7cbd-0032-ead4-f2db9237053a/ccd6dd12-663f-47a4-8d2b-8982ede7aaee/findings_callout_top_ceo_challenges.png?fm=webp&q=15"
    },
    {
        footerDescription: "Only 22% of HR teams prioritize these key future-focused leadership skills.",
        footerStickerURL: "https://assets-us-01.kc-usercontent.com/469992e5-7cbd-0032-ead4-f2db9237053a/21a129fb-16d5-4ee5-a291-38dc32bcd387/findings_callout_critical_skills.png?fm=webp&q=15"
    }
]
///////////////Components

/////////////Report Slider
function ProgressBar({ report, handleLabelClick }) {
    return (
        <div className="progress-outter">
            <div className="progress-labels">
                <p className="progress-label type--header-xsm" onClick={() => handleLabelClick(1)}>
                    Global Leadership Forecast 2025
                </p>
                <p className="progress-label type--header-xsm" style={{ width: "27%", textAlign: "center" }} onClick={() => handleLabelClick(2)}>
                    HR Insights Report 2025
                </p>
                <p className="progress-label type--header-xsm" style={{ width: "30%", textAlign: "right" }} onClick={() => handleLabelClick(3)}>
                    Europe Leadership Report 2025
                </p>
            </div>
            <div
                className={"progress-inner" + " report" + report}
                style={{
                    marginLeft: `${report == 1 ? 0 : ((report - 1) / REPORTS.length) * 100
                        }%`,
                    width: `${(1 / REPORTS.length) * 100 - (report == REPORTS.length ? 0 : 6)
                        }%`
                }}
            ></div>
        </div>
    );
}
function ArrowNavigators({ selectedReport, increment, decrement }) {
    return (
        <div>
            <button
                disabled={selectedReport === 1 ? true : false}
                onClick={decrement}
                className="navigator-button"
            >
                <i className="fal fa-arrow-circle-left navigator-icon left"></i>
            </button>
            <button
                disabled={selectedReport === REPORTS.length ? true : false}
                onClick={increment}
                className="navigator-button"
            >
                <i className="fal fa-arrow-circle-right navigator-icon right"></i>
            </button>
        </div>
    );
}
function DisplayReportSection({ report }) {
    const { title, description, coverURL, ctaURL, btnTheme, ctaText, reportHTML, titleHTML } = REPORTS[report - 1];
    //const builtDescription = description.map(item => <p>{item}</p>)
    return (
        <div className="display-reports-container">
            <div className="report-cover-container">
                <img className="report-cover" src={coverURL} alt={description} />
            </div>
            <div className="report-details-container">
                {/*<h2 className="report-title">{title}</h2>*/}
                <div dangerouslySetInnerHTML={titleHTML}></div>
                <div dangerouslySetInnerHTML={reportHTML}></div>
                <CallToAction url={ctaURL} title={title} theme={btnTheme} linkText={ctaText} />
            </div>
        </div>
    );
}

function CallToAction({ url, title, theme, linkText }) {
    return (
        <a
            href={url} 
            target="blank"
            className={"btn__base btn__base--theme-" + theme}
            rel="nofollow"
        >
            <i class="btn__base__icon-container"></i>{linkText}
        </a>
    );
}
function MobileMenu() {
    return (
        <div className="accordion mobile-accordion" id="accordionExample">
            <div className="card">
                <div className="card-header mobile-accordion-header-container" id="headingOne">
                    <h2 className="mb-0 mobile-accordion-header">
                        <button
                            className="btn btn-link mobile-accordion-header-button blue"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                        >
                            <i>Global Leadership Forecast 2025</i>

                            <i className="fal fa-chevron-down mobile-accordion-icon"></i>
                        </button>
                    </h2>
                </div>

                <div
                    id="collapseOne"
                    className="collapse show"
                    aria-labelledby="headingOne"
                    data-parent="#accordionExample"
                >
                    <div className="card-body">
                        <h2 class="type--header-base"><i>Global Leadership 2025</i>: Insights and Trends</h2>
                        <p class="type--paragraph-base">The Global Leadership Forecast 2025 delivers critical insights into today’s top leadership challenges, including bench strength, trust, and CEOs’ top concerns. For the first time, the report explores AI's impact on leadership roles, teams, and strategies. Based on rigorous research and global data collection, the forecast comprehensively examines the complexities of leadership development, highlighting skill gaps, talent challenges, and the evolving expectations of modern leaders.</p>
                        <p class="type--paragraph-base">Gain insight into the strategies that enable organizations to develop effective, adaptable leadership teams to tackle today’s challenges and seize tomorrow’s opportunities</p>
                        <CallToAction url="https://media.ddiworld.com/research/global-leadership-forecast-2025-report.pdf" title="Download Global Report" linkText="Download Global Report" />
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="card-header mobile-accordion-header-container" id="headingTwo">
                    <h2 className="mb-0 mobile-accordion-header">
                        <button
                            className="btn btn-link mobile-accordion-header-button green"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapseTwo"
                            aria-expanded="true"
                            aria-controls="collapseTwo"
                        >
                            <i>HR Insights Report 2025</i>

                            <i className="fal fa-chevron-down mobile-accordion-icon"></i>
                        </button>
                    </h2>
                </div>

                <div
                    id="collapseTwo"
                    className="collapse show"
                    aria-labelledby="headingTwo"
                    data-parent="#accordionExample"
                >
                    <div className="card-body">
                        <h2 class="type--header-base"><i>HR Insights Report 2025</i>: Strategies for HR's Defining Moment</h2>
                        <p class="type--paragraph-base">The HR Insights Report 2025, part of DDI’s Global Leadership Forecast series, uncovers the most urgent leadership challenges facing HR today—from succession planning and measuring impact to Gen Z turnover and AI transformation.</p>
                        <p class="type--paragraph-base">Drawing on insights from over 2,000 HR professionals, this report highlights the seismic shift from reactive HR to anticipatory leadership. It reveals how HR leaders can build stronger pipelines, drive business results, and prove the ROI of leadership initiatives, positioning HR as an engine of competitive advantage.</p>
                        <p class="type--paragraph-base">Uncover what sets high-impact HR apart—those stuck managing the status quo versus those shaping the future.</p>
                        <CallToAction url="https://media.ddiworld.com/research/global-leadership-forecast-2025-report.pdf" title="Download HR Report" linkText="Download HR Report" />
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="card-header mobile-accordion-header-container" id="headingThree">
                    <h2 className="type--header-base mb-0 mobile-accordion-header">
                        <button
                            className="btn btn-link collapsed mobile-accordion-header-button purple"
                            type="button"
                            data-toggle="collapse"
                            data-target="#collapseThree"
                            aria-expanded="false"
                            aria-controls="collapseThree"
                        >
                            <i>Europe Leadership Report 2025</i>
                            <i className="fal fa-chevron-down mobile-accordion-icon"></i>
                        </button>
                    </h2>
                </div>
                <div
                    id="collapseThree"
                    className="collapse"
                    aria-labelledby="headingThree"
                    data-parent="#accordionExample"
                >
                    <div className="card-body">
                        <h2 class="type--header-base"><i>Europe Leadership Report 2025</i>: Trends, Challenges, and Solutions</h2>
                        <p class="type--paragraph-base">The Europe Leadership Report 2025, part of DDI’s Global Leadership Forecast series, provides essential insights into evolving leadership challenges across Europe</p>
                        <p class="type--paragraph-base">Amid economic turbulence, technological advancements, and shifting workforce dynamics, European leaders face unprecedented pressure to adapt. The report spotlights critical concerns, including leadership stress, trust deficits, readiness for AI integration, and gaps in frontline leaders’ sense of purpose.</p>
                        <p class="type--paragraph-base">Discover evidence-based strategies to rebuild trust, ignite purpose, and cultivate resilient leadership in an ever-changing business landscape.</p>
                        <CallToAction url="https://media.ddiworld.com/research/europe-leadership-report-2025.pdf" title="Download Europe Report" linkText="Download Europe Report" />
                    </div>
                </div>
            </div>
        </div>
    );
}



////////////Findings Slider
function SliderNavigation({ updatePosition, currentPosition }) {
    const navElementPush =
        currentPosition == 1 ? 0 : (currentPosition - 1) * 0.2 * 100;
    return (
        <ul className="slider-navigation-container" role="navigation" aria-label="Report Findings">
            <div
                className="slider-navigation-element"
                style={{
                    marginLeft: `${navElementPush}%`
                }}
            ></div>
            <li className="slider-list-item">
                <span className="slider-link" onClick={() => updatePosition(1)} href="#">
                    Trust &amp;<br />Credibility
                </span>
            </li>
            <li className="slider-list-item">
                <span className="slider-link" onClick={() => updatePosition(2)} href="#">
                    AI at<br />Work
                </span>
            </li>
            <li className="slider-list-item">
                <span className="slider-link" onClick={() => updatePosition(3)} href="#">
                    Stress &amp;<br />Retention
                </span>
            </li>
            <li className="slider-list-item">
                <span className="slider-link" onClick={() => updatePosition(4)} href="#">
                    Top CEO<br />Challenges
                </span>
            </li>
            <li className="slider-list-item">
                <span className="slider-link" onClick={() => updatePosition(5)} href="#">
                    Critical<br />Skills
                </span>
            </li>
        </ul>
    );
}
function SliderContent({ currentPosition }) {
    return (
        <div className="slider-content-outter-container">
            <div className="slider-content">
                <div
                    className="slide default"
                    style={{
                        opacity: `${currentPosition == 1 ? 1 : 0}`,

                    }}
                >
                    <div className="slide-content-container"
                        style={{
                            zIndex: `${currentPosition == 1 ? "1000" : "auto"}`
                        }}
                    >
                        <p className="slide-overline type--overline">Report Finding</p>
                        <p className="slide-headline type--header-base">Leadership Trust Crisis</p>
                        <p className="slide-content type--paragraph-base">
                            Leadership credibility  is eroding, with trust in managers dropping from 46% to 29%   since 2022. Global challenges, workplace polarization,
                            and generational divides intensify the leadership trust crisis. Without strategic intervention, this erosion threatens retention, weakens
                            leadership pipelines, and undermines organizational performance.{" "}
                        </p>
                    </div>
                    <div className="slide-image-container">
                        <img className="slide-image d-none d-lg-block img-fluid" src="https://assets-us-01.kc-usercontent.com/469992e5-7cbd-0032-ead4-f2db9237053a/10a01ff5-dbf6-4998-ab30-0995ffca691b/findings_trust_plummets.png?fm=webp&q=15" alt="Top CEO Challenges" />
                    </div>
                </div>
                <div
                    className="slide"
                    style={{
                        opacity: `${currentPosition == 2 ? 1 : 0}`
                    }}
                >
                    <div className="slide-content-container"
                        style={{
                            zIndex: `${currentPosition == 2 ? "1000" : "auto"}`
                        }}
                    >
                        <p className="slide-overline type--overline">Report Finding</p>
                        <p className="slide-headline type--header-base">Leadership AI Divide</p>
                        <p className="slide-content type--paragraph-base">
                            AI adoption exposes a leadership divide: Frontline managers, burdened by implementation responsibilities, are 3X more likely to be
                            concerned about the impact of AI than senior leaders. Low trust in senior leadership further hinders their alignment.  Success hinges
                            on bridging this gap through transparent communication, collaborative involvement, and aligned leadership teams.{" "}
                        </p>
                    </div>
                    <div className="slide-image-container">
                        <img className="d-lg-block img-fluid" src="https://assets-us-01.kc-usercontent.com/469992e5-7cbd-0032-ead4-f2db9237053a/2e166907-8251-48ec-82bf-fb717e374f65/findings_ai_at_work_cropped.png?fm=webp&q=15" alt="Leadership AI Divide" />
                    </div>
                </div>
                <div
                    className="slide"
                    style={{
                        opacity: `${currentPosition == 3 ? 1 : 0}`
                    }}
                >
                    <div className="slide-content-container"
                        style={{
                            zIndex: `${currentPosition == 3 ? "1000" : "auto"}`
                        }}
                    >
                        <p className="slide-overline type--overline">Report Finding</p>
                        <p className="slide-headline type--header-base">Leaders Under Pressure</p>
                        <p className="slide-content type--paragraph-base">
                            Leader stress is escalating, with 71% reporting increased stress and 54% of those leaders feeling concerned about burnout.
                            Time scarcity is a key driver, with only 30% feeling they have enough time to fulfill their responsibilities. Alarmingly,
                            40% of leaders who reported increased stress said they also considered leaving their leadership role,  revealing a systemic
                            risk to leadership pipelines and highlighting the critical need for organizations to reimagine how they support and empower
                            their leaders. {" "}
                        </p>
                    </div>
                    <div className="slide-image-container">
                        <img className="d-lg-block img-fluid" src="https://assets-us-01.kc-usercontent.com/469992e5-7cbd-0032-ead4-f2db9237053a/1ea562b5-42b3-4a0b-8fd2-51b812d3c8d5/findings_stress_increases_cropped.png?fm=webp&q=15" alt="Leaders under pressure" />
                    </div>
                </div>
                <div
                    className="slide"
                    style={{
                        opacity: `${currentPosition == 4 ? 1 : 0}`
                    }}
                >
                    <div className="slide-content-container"
                        style={{
                            zIndex: `${currentPosition == 4 ? "1000" : "auto"}`
                        }}
                    >
                        <p className="slide-overline type--overline">Report Finding</p>
                        <p className="slide-headline type--header-base">Top Talent Dilemma</p>
                        <p className="slide-content type--paragraph-base">
                            CEOs face a critical paradox: retaining top talent while managing
                            costs amid economic uncertainty. More than half rank talent as
                            their primary concern for the next five years. For them, the risk
                            is clear: Economic pressures may demand cuts, but losing key talent
                            risks eroding leadership pipelines and resilience. Long-term
                            success hinges on balancing talent investment with fiscal
                            prudence.{" "}
                        </p>
                    </div>
                    <div className="slide-image-container">
                        <img className="d-lg-block img-fluid" src="https://assets-us-01.kc-usercontent.com/469992e5-7cbd-0032-ead4-f2db9237053a/2fa1c807-ec86-462e-8219-7b55ffa7a36b/findings_top_ceo_challenges_cropped.png?fm=webp&q=15" alt="Future skills shortfall" />
                    </div>
                </div>
                <div
                    className={`slide ${2 + 2}`}
                    style={{
                        opacity: `${currentPosition == 5 ? 1 : 0}`
                    }}
                >
                    <div className="slide-content-container"
                        style={{
                            zIndex: `${currentPosition == 5 ? "1000" : "auto"}`
                        }}
                    >
                        <p className="slide-overline type--overline">Report Finding</p>
                        <p className="slide-headline type--header-base">Future Skills Shortfall</p>
                        <p className="slide-content type--paragraph-base">
                            Eighty-three percent of HR leaders say there is a growing demand for new leadership skills, yet development lags. Key future-focused
                            skills—setting strategy, change management, talent development, and decision making—remain critically underdeveloped, threatening
                            innovation and growth in an evolving business landscape.{" "}
                        </p>
                    </div>
                    <div className="slide-image-container">
                        <img className="d-lg-block img-fluid" src="https://assets-us-01.kc-usercontent.com/469992e5-7cbd-0032-ead4-f2db9237053a/504a137c-c496-472c-869c-c44069fe9063/findings_critical_skills_cropped.png?fm=webp&q=15" alt="Top talent Dilemna" />
                    </div>
                </div>
            </div>
        </div>
    );
}
function SliderFooter({ currentPosition }) {
    const { footerDescription, footerStickerURL } = FINDINGS[currentPosition - 1];
    return (
        <div className="slider-footer">
            <div className="slider-footer-container">
                <div className="slider-sticker-container">
                    <img src={footerStickerURL} alt={footerDescription} className="slider-sticker" />
                </div>
                <div className="slider-footer-content-container">
                    <p className="slider-footer-description type--fontfam-robotoslab">{footerDescription}</p>
                </div>
            </div>
        </div>
    )
}